import { render, staticRenderFns } from "./codeBindBuygwc.vue?vue&type=template&id=2222abd5&scoped=true"
import script from "./codeBindBuygwc.vue?vue&type=script&lang=js"
export * from "./codeBindBuygwc.vue?vue&type=script&lang=js"
import style0 from "./codeBindBuygwc.vue?vue&type=style&index=0&id=2222abd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222abd5",
  null
  
)

export default component.exports